<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Administración de Documentos</h2>
    <div v-if="houses.length" class="grid grid-cols-12 gap-6 mt-5 max-w-xl">
      <div class="col-span-12 md:col-span-9">
        <label class="form-label">Seleccione la residencia</label>
        <select
          v-model="houseSelected"
          data-placeholder="Selecciona la residencia"
          class="w-full form-select mt-1"
          @change="houseChanged"
        >
          <option v-for="item in houses" :key="item.id" :value="item">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>
    <div
      v-if="houseSelected && residents.length"
      class="grid grid-cols-12 gap-6 mt-5 max-w-xl"
    >
      <div class="col-span-12 md:col-span-9">
        <label class="form-label">Seleccione el residente</label>
        <select
          v-model="residentSelected"
          data-placeholder="Selecciona el residente"
          class="w-full form-select mt-1"
          @change="residentChanged"
        >
          <option v-for="item in residents" :key="item.id" :value="item">
            {{ item.full_name }}
          </option>
        </select>
      </div>
    </div>
    <h1
      v-else-if="houseSelected"
      class="my-10 text-center text-2xl font-medium"
    >
      La casa seleccionada no tiene residentes
    </h1>
    <!-- AÑADIR DOCS -->
    <div class="grid grid-cols-12 gap-6 mt-5" v-if="residentSelected">
      <div
        class="
          intro-y
          col-span-12
          flex flex-wrap
          sm:flex-nowrap
          items-center
          mt-2
          ml-auto
        "
      >
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <select
                v-model="dateSelected"
                class="form-select box"
                @change="residentChange"
              >
                <option
                  v-for="(date, key) in dates"
                  :key="key"
                  :value="date.original"
                >
                  {{ date.human }}
                </option>
              </select>
        </div>
        <div class="w-full sm:w-auto mt-3 ml-3 sm:mt-0 sm:ml-0 md:ml-3">
          <input type="file" id="upload-file" name="upload-file" @change="onFileSelected" hidden>
          <label for="upload-file" refs="upload-file" class="btn btn-primary">Subir Documento</label>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5" v-if="residentSelected">
      <div
        class="
          intro-y
          col-span-12
          flex flex-wrap
          sm:flex-nowrap
          items-center
          mt-2
          ml-auto
        "
      >
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="relative text-gray-700 dark:text-gray-300">
            <input
              v-model="search"
              type="text"
              class="form-control w-72 box pr-10 placeholder-theme-13"
              placeholder="Buscar"
              @change="setFirstPage"
            />
            <SearchIcon
              class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
            />
          </div>
        </div>
      </div>
      <!-- BEGIN: Data List -->
      <template v-if="docsData">
        <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table
            class="table table-report -mt-2"
            aria-describedby="administrators table"
          >
            <thead>
              <tr>
                <!-- <th id="url" class="text-center whitespace-nowrap">
                  Url
                </th> -->
                <th id="name" class="text-center whitespace-nowrap">
                  name
                </th>
                <th id="created" class="text-center whitespace-nowrap">
                  Creado
                </th>
                <th id="actionsH" class="text-center whitespace-nowrap">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr :key="row.id" v-for="row in elements">
                <!-- <td class="text-center w-10 font-medium">
                  {{ row.url }}
                </td> -->
                <td class="text-center w-10 font-medium">
                  {{ row.name }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.created_at }}
                </td>
                <td class="table-report__action w-56">
                  <div class="flex justify-center items-center">
                    <a
                        href="javascript:;"
                        class="flex items-center mr-3 text-green-600"
                        @click="setToDelete(row)"
                      >
                        <Trash2Icon class="w-4 h-4 mr-1" /> Eliminar
                    </a>
                    <div v-if="ios">
                      <a v-if="row.url" :href="row.url" target="_blank" width="300px" height="400px" >
                        <BookOpenIcon class="w-4 h-4 mr-1" /> Abrir
                      </a>
                    </div>
                    <div v-else>
                      <a
                        href="javascript:;"
                        class="flex items-center text-red-700"
                        @click="setVisualize(row)"
                      >
                        <BookOpenIcon class="w-4 h-4 mr-1" /> Abrir
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END: Data List -->
        <!-- BEGIN: Pagination -->
        <div
          class="
            intro-y
            col-span-12
            flex flex-wrap
            sm:flex-row sm:flex-nowrap
            items-center
            pb-10
          "
          v-if="pages > 1"
        >
          <ul class="pagination ml-auto" style="margin-right: revert;">
            <li @click="setFirstPage" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronsLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="changePageNegative" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li
              :key="element"
              v-for="element in [...Array(maxShowButtonPages).keys()].map(
                (dataElement, index) =>
                  activeGroup * maxShowButtonPages -
                  (maxShowButtonPages - index) +
                  1
              )"
            >
              <template v-if="element <= pages">
                <a
                  class="pagination__link"
                  href="javascript:;"
                  @click="page = element"
                  :class="{ 'pagination__link--active': element === page }"
                  >{{ element }}
                </a>
              </template>
            </li>
            <li v-if="page !== pages" @click="changePagePositive">
              <a class="pagination__link" href="javascript:;">
                <ChevronRightIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="setlastPage" v-if="page !== pages">
              <a class="pagination__link" href="javascript:;">
                <ChevronsRightIcon class="w-4 h-4" />
              </a>
            </li>
          </ul>
        </div>
        <!-- END: Pagination -->
        <!-- BEGIN: Delete Confirmation Modal -->
        <div ref="deleteRow" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div v-if="rowSelected" class="modal-body p-0">
                <div class="p-5 text-center">
                  <XCircleIcon class="w-16 h-16 text-red-700 mx-auto mt-3" />
                  <div class="text-3xl mt-5">¿Estás seguro?</div>
                  <div class="text-gray-600 mt-2">
                    ¿Realmente quieres eliminar el registro
                    <span style="font-weight: bold">{{ rowSelected.name }}</span
                    >?
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button
                    type="button"
                    data-dismiss="modal"
                    class="btn btn-outline-secondary w-24 mr-1"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger w-24"
                    @click="deleteAction"
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Delete Confirmation Modal -->
        <!-- BEGIN: DOCUMENT MODAL -->
        <div ref="visualizeRow" class="modal">
          <div class="modal-dialog" width="800px">
            <div class="modal-content align-center" width="800px">
              <div v-if="rowSelected" >
                  <div v-if="$isMobile()">
                    <embed class="ml-5 align-center" v-if="rowSelected.url" :src="rowSelected.url" type="application/pdf" width="300px" height="400px" />
                  </div>
                  <div v-else-if="tablet">
                    <embed v-if="rowSelected.url" :src="rowSelected.url" type="application/pdf" width="400px" height="450px" />
                  </div>
                  <div v-else>
                    <embed v-if="rowSelected.url" :src="rowSelected.url" type="application/pdf" width="800px" height="800px" />
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: DOCUMENT MODAL -->
      </template>
    </div>
  </div>
</template>

<script>
import { cleanSession, getFirstErrorMessage } from '../../../utils/tools'
import moment from 'moment-timezone'
import { isTablet, isAndroid } from 'mobile-device-detect'

export default {
  data() {
    return {
      dateSelected: '',
      moment: moment,
      momentClass: moment,
      houses: [],
      houseSelected: undefined,
      residents: [],
      residentSelected: undefined,
      docsData: [],
      medicines: undefined,
      rowSelected: undefined,
      search: '',
      elementsByPage: 3,
      maxShowButtonPages: 3,
      tablet: isTablet,
      ios: isAndroid,
      page: 1,
      activeGroup: 1,
      createForm: {
        resident_id: undefined,
        medicine_id: undefined,
        type: undefined,
        dose: undefined
      },
      dates: []
    }
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    await this.getInitialData()
    this.$store.commit('main/setShowSpinner', false)
    window.scrollTo(0, 0)
    for (let i = 0; i < 30; i++) {
      let date = this.moment()
      date = date.subtract(i, 'day')
      this.dates.push({
        human: date.format('DD-MM-YYYY'),
        original: date.format('YYYY-MM-DD')
      })
    }
    this.dateSelected = this.dates[0].original
  },
  methods: {
    async getInitialData() {
      try {
        const response = await this.axios.get('/houses', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.houses = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async houseChanged() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get('/residents-by-house', {
          params: { houseId: this.houseSelected.id },
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.residents = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async residentChanged() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get(
          `/documents-by-resident/${this.residentSelected.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.docsData = response.data || []
        console.log(this.docsData)
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    setVisualize(row) {
      this.rowSelected = row
      const modal = this.$refs.visualizeRow
      console.log(this.rowSelected)
      cash(modal).modal('show')
    },
    setToDelete(row) {
      this.rowSelected = row
      const modal = this.$refs.deleteRow
      console.log(this.rowSelected)
      cash(modal).modal('show')
    },
    async deleteAction() {
      const modal = this.$refs.deleteRow
      cash(modal).modal('hide')
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-document/${this.rowSelected.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.getInitialData()
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async onFileSelected(event) {
      this.selectedFile = event.target.files[0]
      console.log(this.selectedFile)
      console.log(this.dateSelected)
      this.onUpload()
    },
    async onUpload() {
      const form = new FormData()
      form.append('file', this.selectedFile)
      await this.axios(
        {
          method: 'post',
          url: `/edit-doc-resident/${this.residentSelected.id}/${this.dateSelected}`,
          data: form,
          headers: { Authorization: `Bearer ${this.$store.state.auth.token}` }
        })
        .then(res => {
          this.$toast.success(
            'El registro ha sido añadido satisfactoriamente',
            {
              position: 'top'
            }
          )
        })
    },
    changePagePositive() {
      const page = this.page + 1
      if (page > this.activeGroup * this.maxShowButtonPages) {
        this.activeGroup++
      }
      this.page++
    },
    changePageNegative() {
      const page = this.page - 1
      if (page <= (this.activeGroup - 1) * this.maxShowButtonPages) {
        this.activeGroup = this.activeGroup - 1 === 0 ? 1 : this.activeGroup - 1
      }
      this.page--
    },
    setFirstPage() {
      this.page = 1
      this.activeGroup = 1
    },
    setlastPage() {
      this.page = this.pages
      this.activeGroup = this.totalGroups
    },
    showModalCreate(row) {
      this.createForm = {
        resident_id: this.residentSelected.id,
        medicine_id: row.id,
        type: undefined,
        dose: undefined
      }
      const modal = this.$refs.createRow
      cash(modal).modal('show')
    },
    changeKardexType() {
      this.createForm = {
        resident_id: this.createForm.resident_id,
        medicine_id: this.createForm.medicine_id,
        type: this.createForm.type,
        dose: this.createForm.dose
      }
    },
    async createAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.createRow
      cash(modal).modal('hide')
      try {
        await this.axios.post(
          '/create-kardex',
          {
            ...this.createForm
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        await this.residentChanged()
        this.$toast.success('El registro se ha creado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async deleteItemKardex(kardexId) {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-kardex/${kardexId}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.residentChanged()
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    }
  },
  computed: {
    filteredElements() {
      if (this.docsData) {
        let elements = this.docsData
        if (this.search && this.search.length) {
          elements = elements.filter(
            row =>
              row.url
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase())
          )
        }
        return elements
      }
      return []
    },
    elements: function() {
      if (this.filteredElements) {
        const takeElements =
          this.elementsByPage * this.page - this.filteredElements.length < 0
            ? this.elementsByPage * this.page
            : this.filteredElements.length
        return this.filteredElements.slice(
          this.elementsByPage * this.page - this.elementsByPage,
          takeElements
        )
      }
      return []
    },
    pages: function() {
      return this.filteredElements
        ? Math.ceil(this.filteredElements.length / this.elementsByPage)
        : 1
    },
    totalGroups: function() {
      return Math.ceil(this.pages / this.maxShowButtonPages)
    }
  }
}
</script>
